
import { EditableObject } from "../bean/EditableObject";

class objectServices {

  async getListeObjectByUser(p_key) {
    // console.log("getListeObjectByUser debut: "+pp_user);
    let v_retour = [];

    const requestOptions = {
      method: "GET",
      mode: 'cors',
      headers: { "Content-Type": "application/json" }
    };

    try {
      //const response = await fetch("https://hook.eu2.make.com/2v5lf79iwtckvc85j4zdcm64ov52sngm?api=getbyuser", requestOptions)
      const timestamp = Date.now(); //To avoid cache data
      const response = await fetch("https://app.listaki.fr/api/WS/getListObjectByKey.php?key=" + p_key + "&r=" + timestamp, requestOptions)
      if (response.ok) {
        v_retour = await response.json()
      } else {
        console.log("Erreur lors de l'appel à l'API");
      }
    } catch (err) {
      console.log(err)
    } finally {
      return v_retour;
    }
  };

  async addEditableObjectByKey(p_key, p_user, p_editableObject) {
  let v_retour = null;
  console.log("addEditableObjectByKey debut");
  console.log(p_user);
  console.log(p_editableObject);
  let v_objectName = p_editableObject.title;
  if (!v_objectName || v_objectName === null || v_objectName === '') {
    v_objectName = "Sans nom";
  }

  const requestOptions = {
    method: "POST",
    mode: 'cors',
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      username: p_user,
      objectname: v_objectName,
      urllink: p_editableObject.url,
      imagelink: p_editableObject ? p_editableObject.imagelink : "", //Sinon le WS dit param imagelink manquant
      price: p_editableObject.price,
      description: p_editableObject.description,
      idList: p_editableObject.idList
    }),
  };

  try {
    let v_responseJson = {};
    const response = await fetch("https://app.listaki.fr/api/WS/createObjectByKey.php?key=" + p_key, requestOptions)
    if (response.ok) {
      v_responseJson = await response.json();
      v_retour = await v_responseJson;
      console.log("Reponse api debut");
      console.log(v_responseJson)
      console.log("Reponse api fin");
      console.log("v_retour : ", v_retour);
    } else {
      console.log("Erreur lors de l'appel à l'API");
    }
  } catch (err) {
    console.log(err)
  }  
    return v_retour;
};

  async updateEditableObjectByKey(p_key, p_user, p_editableObject) {
  let v_retour = null;
  console.log("updateObjectByKey début");
  console.log(p_user);
  console.log(p_editableObject);

  let v_objectName = p_editableObject.title;
  if (!v_objectName) {
    v_objectName = "Sans nom";
  }

  const requestOptions = {
    method: "POST",
    mode: 'cors',
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: p_editableObject.id,
      username: p_user,
      objectname: v_objectName,
      urllink: p_editableObject.url,
      imagelink: p_editableObject.imagelink,
      price: p_editableObject.price,
      description: p_editableObject.description,
      idList: p_editableObject.idList
    }),
  };

  try {
    const response = await fetch(`https://app.listaki.fr/api/WS/updateObjectByKey.php?key=${p_key}`, requestOptions);
    if (response.ok) {
      const v_responseJson = await response.json();
      v_retour = await v_responseJson;
      console.log("Réponse API :", v_responseJson);
    } else {
      console.log("Erreur lors de l'appel à l'API");
    }
  } catch (err) {
    console.error(err);
  }
    return v_retour;
};

  async deleteObject(p_key, p_id) {
  let v_retour = false;
  console.log("deleteObject");
  console.log(p_id);

  const requestOptions = {
    method: "POST",
    mode: 'cors',
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: p_id
    }),
  };

  try {
    const response = await fetch("https://app.listaki.fr/api/WS/deleteObject.php?key=" + p_key, requestOptions)
    if (response.ok) {
      const v_response = await response;
      console.log(v_response);
      const v_responseJson = await v_response.json();
      console.log("Reponse api debut");
      console.log(v_responseJson)
      console.log("Reponse api fin");
      if (v_responseJson['success'] === true)
        v_retour = true
    } else {
      console.log("Erreur lors de l'appel à l'API");
    }

  } catch (err) {
    console.log('Erreur : ' + err)
  } finally {
      return v_retour;
  }
}

  async updateObjectByKey(p_key, p_user, p_formData) {

    let v_retour = null;
  console.log("updateObjectByKey debut");
  console.log(p_user);
  console.log(p_formData);
  console.log(p_formData.nameObject);

  let v_objectName = p_formData.nameObject;
  if (v_objectName === null || v_objectName === '') {
    v_objectName = "Sans nom";
  }

  const requestOptions = {
    method: "POST",
    mode: 'cors',
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: p_formData.id,
      username: p_user,
      objectname: p_formData.nameObject,
      urllink: p_formData.link,
      imagelink: p_formData.image,
      price: p_formData.price,
      description: p_formData.description,
      idList: p_formData.idList
    }),
  };

  try {
    let v_responseJson = {};
    //const response = await fetch("https://hook.eu2.make.com/2v5lf79iwtckvc85j4zdcm64ov52sngm?api=create", requestOptions)
    const response = await fetch("https://app.listaki.fr/api/WS/updateObjectByKey.php?key=" + p_key, requestOptions)
    if (response.ok) {
      v_responseJson = await response.json();
      v_retour = v_responseJson;
      console.log("Reponse api debut");
      console.log(v_responseJson)
      console.log("Reponse api fin");
      // addToList(v_responseJson.id, v_objectName, v_responseJson.link, p_formData.image, p_formData.price, p_formData.description,p_formData.site);
      // annuleForm();
    } else {
      console.log("Erreur lors de l'appel à l'API");
    }
  } catch (err) {
    console.log(err)
  } finally {
    return v_retour;
  }
};
}

export default new objectServices();